
(function(){
  const storeDomain = "1rsu0u-a1.myshopify.com";
  const accessToken = "89809c6a1459052f0b6d4c7f181374fa";
  const collectionHandle = "smart-grab-go-picks";
  const containerId = "collection-product-list";

  function renderProducts(container, products) {
    container.innerHTML = "";
    container.style.display = "flex";
    container.style.flexWrap = "wrap";
    container.style.justifyContent = "center";
    container.style.gap = "20px";

    products.forEach(p => {
      const title = p.title;
      const handle = p.handle;
      const imageUrl = p.featuredImage?.url || "";
      const altText = p.featuredImage?.altText || p.title;
      const price = parseFloat(p.priceRange.minVariantPrice.amount).toFixed(2);

      const productHTML = `
        <div class="product-card" style="flex: 0 1 200px; text-align: center; padding: 10px;">
          <a href="#" class="impulse-link" data-href="/products/${handle}" style="text-decoration: none;">
            <img src="${imageUrl}" alt="${altText}" style="width: 100%; max-width: 200px; height: 200px; object-fit: cover; display: block; margin: 0 auto;" />
            <h3 style="margin: 0.5em 0; color: black;">${title}</h3>
            <p><strong>$${price}</strong></p>
            <div class="button" style="margin-top: 0.5em; background: #f4b400; color: #000; padding: 10px; border-radius: 5px;">View Product</div>
          </a>
        </div>
      `;
      container.insertAdjacentHTML("beforeend", productHTML);
    });

    // Attach redirect with cart-add logic
    document.querySelectorAll(".impulse-link").forEach(link => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        const targetHref = this.getAttribute("data-href");
        const submitBtn = document.querySelector(".gbbSummaryPageCheckoutButton");
        if (submitBtn) {
          submitBtn.click(); // triggers bundle submission to cart
          setTimeout(() => {
            window.location.href = targetHref;
          }, 1000); // allow time for cart update
        } else {
          window.location.href = targetHref;
        }
      });
    });
  }

  async function fetchProducts() {
    const query = `
      query {
        collectionByHandle(handle: "${collectionHandle}") {
          products(first: 6) {
            edges {
              node {
                title
                handle
                featuredImage {
                  url
                  altText
                }
                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      }
    `;
    const response = await fetch(`https://${storeDomain}/api/2023-10/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken
      },
      body: JSON.stringify({ query })
    });
    const data = await response.json();
    return data.data.collectionByHandle?.products.edges.map(e => e.node) || [];
  }

  function initImpulseItems() {
    const container = document.getElementById(containerId);
    if (container) {
      console.log("[Impulse] ✅ Found #" + containerId);
      fetchProducts()
        .then(products => {
          console.log("[Impulse] 🛍 Products loaded:", products);
          renderProducts(container, products);
        })
        .catch(e => console.error("[Impulse] ❌ Failed to load products:", e));
    }
  }

  if (window.location.pathname.includes("/build-your-big-custom-box") ||
      window.location.pathname.includes("/build-your-classic-custom-box") || 
      window.location.pathname.includes("/ranchise-owners-build-your-classic-custom-box")) {
    console.log("[Impulse] 📦 Initializing with observer...");

    const observer = new MutationObserver(() => {
      const container = document.getElementById(containerId);
      if (container) {
        observer.disconnect();
        initImpulseItems();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    console.log("[Impulse] 😴 Skipping product render — not the correct page.");
  }

  if (typeof window.loadMoreProducts !== "function") {
    window.loadMoreProducts = () => {};
  }
})();
